import AppHeader from '@/components/Elements/Header/AppHeader';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  title?: string;
  registeredStatus?: string;
  backButton?: boolean;
  handleBack?: () => void;
  linkToMypage?: () => void; // feature/reservation と feature/myPage から呼ばれておりこのpropsはfeature/myPageのためのもの
}

const Layout = ({ children, title, registeredStatus, backButton = true, handleBack, linkToMypage }: Props) => {
  return (
    <>
      <AppHeader
        title={title}
        registeredStatus={registeredStatus}
        showBackButton={backButton}
        handleBack={handleBack}
        handleTop={linkToMypage}
      />
      {children}
    </>
  );
};
export default Layout;
